// API Configuration
// Priority: window._env_ (runtime, editable on server) → process.env (build-time) → default
declare global {
  interface Window {
    _env_?: {
      REACT_APP_API_URL?: string;
    };
  }
}

export const API_URL: string =
  window._env_?.REACT_APP_API_URL ||
  process.env.REACT_APP_API_URL ||
  'http://localhost:8000/api/v1';
export const AUTH_URL = `${API_URL}/auth`;
export const TOKEN_URL = `${AUTH_URL}/token`;
export const CURRENT_USER_URL = `${AUTH_URL}/users/me`;
export const INVITATIONS_URL = `${AUTH_URL}/invitations`;